import { advantages } from '@/mocks/homeData';

export default function AdvantagesSection() {
  return (
    <section className="relative w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 tracking-tight mb-3">
            为什么选择开云体育
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            以用户为中心，打造极致安全流畅的体育娱乐体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {advantages.map((adv, idx) => (
            <div
              key={idx}
              className="group relative bg-background-50 border border-background-200 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${adv.icon} text-xl md:text-2xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">
                {adv.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {adv.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}